import { render, staticRenderFns } from "./service-search-result.vue?vue&type=template&id=4d5edef2&scoped=true&"
import script from "./service-search-result.vue?vue&type=script&lang=js&"
export * from "./service-search-result.vue?vue&type=script&lang=js&"
import style0 from "./service-search-result.vue?vue&type=style&index=0&id=4d5edef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5edef2",
  null
  
)

export default component.exports